import { DialogType } from '@tableau/widgets';
import React from 'react';

import { ModalInstance, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { AddKeyPairAuthCredentialDialog, PrivateKeyAuthProps } from '~src/connectivity/components/AddKeyPairAuthCredentialDialog';
import { IAddKeyPairAuthCredentialResult } from '~src/connectivity/serverApi/requests/credentials/AddKeyPairAuthCredentialRequest';
import { addPrivateKeyDialogStyle } from '~src/connectivity/styles/AddKeyPairAuthDialogStyles';

export namespace AddKeyPairAuthCredentialAction {
    export function addKeyPairAuthCredential(type: string): Promise<IAddKeyPairAuthCredentialResult> {
        let modalInstance: ModalInstance<IAddKeyPairAuthCredentialResult>;
        const dialogProps: PrivateKeyAuthProps = {
          dbClass: type,
          dismiss: () => modalInstance?.dismiss(),
          close: (result: IAddKeyPairAuthCredentialResult) => modalInstance?.close(result),
        };

        modalInstance = ReactModalService.open({
          type: DialogType.Uber,
          dialogContent: React.createElement(AddKeyPairAuthCredentialDialog, dialogProps),
          testId: 'addKeyPairAuthCredentialDialog',
          showCloseButton: true,
          dialogStyle: addPrivateKeyDialogStyle,
          shouldNotSetDefaultWidth: true
        });
        return modalInstance.result;
    }
}
